import React from 'react'
import * as Icon from 'react-feather'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Row, Col, Button, Input, Progress, Spinner } from 'reactstrap'
import Checkbox from "../../../../components/@vuexy/checkbox/CheckboxesVuexy"

// Pixacom imports
import { endWork } from "../../../../redux/actions/activity/activityActions"
import { updateTasks } from '../../../../redux/actions/todo/index'

class CompleteModal extends React.Component {
    state = {
        modalComplete: this.props.modalComplete,
        modalCompletePending: false,
        messageComplete: '',
        setTimeComplete: false,
        timeComplete: null,
        itemToComplete: this.props.itemToComplete,
        filter: this.props.filter
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modalComplete !== this.props.modalComplete) {
            this.setState({ modalComplete: this.props.modalComplete, itemToComplete: this.props.itemToComplete });
        }
    }

    render() {
        return (
            <Modal
                isOpen={this.state.modalComplete}
                toggle={this.props.toggleModalComplete}
                className="modal-dialog-centered"
            >
                <ModalHeader toggle={!this.state.modalCompletePending ? this.props.toggleModalComplete : null}>
                    <FormattedMessage id="Complete" defaultMessage="Complete" />
                </ModalHeader>

                <ModalBody>
                    <Row className="pb-1">
                        <Col md="12" sm="12">
                            <small>Úkol:</small><br />
                            {this.state.itemToComplete ? this.state.itemToComplete.subject : ""}
                        </Col>   
                    </Row>
                    <Row>
                        <Col md="12" sm="12">
                            <small>Odpracováno:</small><br />
                            {this.state.itemToComplete && 
                            <React.Fragment>
                                { (Math.trunc(this.state.itemToComplete.workTime / 60)) + "h " + parseInt((this.state.itemToComplete.workTime % 60)) + "m" + " logged" }
                                <Progress
                                    value={this.state.itemToComplete.workTime} 
                                    color={this.state.itemToComplete.workTime / this.state.itemToComplete.remainingTime >= 1 ? "success" : (this.state.itemToComplete.workTime / this.state.itemToComplete.remainingTime > 0.5 ? "warning" : "danger" )}
                                    max={this.state.itemToComplete.remainingTime}
                                ></Progress>
                            </React.Fragment>}
                        </Col>   
                    </Row>
                    <Row className="pb-1">
                        <Col md="12" sm="12">
                            <small>Odpracovaný čas:</small><br />
                            <Checkbox
                                //id={item.title}
                                icon={<Icon.Check className="vx-icon" size={16} />}
                                label='Vyplnit automaticky'
                                onChange={e => this.setState({ setTimeComplete : !this.state.setTimeComplete })}
                                checked={!this.state.setTimeComplete}
                            />
                        </Col>
                        {this.state.setTimeComplete &&
                        <Col md="6" sm="12">
                            <Input 
                                type="text"
                                pattern="([1-9]?[0-9]{1}h( )?)?([1-5]?[0-9]{1}m)?"
                                placeholder="6h 45m"
                                onChange={e => this.setState({ timeComplete : e.target.value })}
                            />
                        </Col>
                        }
                    </Row>
                    <Row>
                        <Col md="12" sm="12">
                            <small>Popis práce:</small>
                            <FormGroup>
                                <Input
                                    type="textarea"
                                    placeholder="Sem můžete něco dopsat"
                                    rows="5"
                                    disabled={this.state.modalCompletePending}
                                    onChange={e => this.setState({ messageComplete : e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>

                <ModalFooter>
                    {!this.state.modalCompletePending && 
                    <Button.Ripple
                        color="primary"
                        type="submit"
                        className="mr-1 mb-1"
                        disabled={this.state.modalCompletePending}
                        onClick={async (e) => {
                            e.preventDefault();
                            let taskID = this.state.itemToComplete.id;
                            const fragment = {
                                ...this.props.activity.lastActivity,
                                note: this.state.messageComplete,
                                workTime: this.state.setTimeComplete ? this.state.timeComplete : null,
                                taskID: taskID
                            }
                            this.setState({ modalCompletePending: true }, async () => {
                                await this.props.endWork(fragment);
                                this.props.updateTasks(taskID, 'update');
                                this.setState({ messageComplete: '', modalCompletePending: false }, () => {
                                    if (this.props.onSubmit !== null && this.props.onSubmit !== undefined) {
                                        this.props.onSubmit();
                                    }
                                    this.props.toggleModalComplete();
                                });
                            })
                        }}
                    >
                        <FormattedMessage id="Complete" defaultMessage="Complete" />
                    </Button.Ripple>}
                    {this.state.modalCompletePending &&
                    <Button color="primary">
                        <Spinner color="white" size="sm" />
                        <span className="ml-50"><FormattedMessage id="Saving" defaultMessage="Saving" />...</span>
                    </Button>}
                    <Button.Ripple
                        color="warning"
                        type="submit"
                        className="mr-1 mb-1"
                        disabled={this.state.modalCompletePending}
                        onClick={(e) => {e.preventDefault(); this.props.toggleModalComplete(); }}
                    >
                        <FormattedMessage id="Cancel" defaultMessage="Cancel" />
                    </Button.Ripple>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        store: state.todoApp,
        activity: state.activity.action
    }
}

export default connect(mapStateToProps, {
    updateTasks,
    endWork,
}) (CompleteModal)